import React, { useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { urlDomain } from "../../config/constant";
import { googleAuthClientID } from "../../config/config";
import indiaMARTLogo from '../../images/indiaMARTlogo.png'


const [clientId] = googleAuthClientID();

const GoogleLoginComponent = ({ onLoginSuccess, ip, loginMessage, setLoginMessage }) => {  
  const navigate = useNavigate(); 
  const apiDomain = urlDomain();
  const handleLoginSuccess = (credentialResponse) => {
    const token = credentialResponse.credential;
    const redirectUrl = localStorage.getItem("previousPathUrl");
    
    fetch(`${apiDomain}/auth/google-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, ip }),
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          localStorage.removeItem("logoutFlag");
          onLoginSuccess(data.user);
          const defaultUrl = `/api/html?empid=${data.user.empid}`;

          const isInvalidRedirect =
            !redirectUrl ||
            redirectUrl === "/" ||
            redirectUrl === "/login.php" ||
            redirectUrl.includes("msg=1") ||
            redirectUrl.includes("msg=2");

          navigate(isInvalidRedirect ? defaultUrl : redirectUrl);
        } else {
          console.log("Login failed:", data.message);
          setLoginMessage(data.message)
        }
      })
      .catch((err) => console.error(err));
  };
  

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <div className="logo_wrapper">
          <h1 className="logo_heading">
            <img
              id="login-logo-new1"
              className="standard_logo"
              src={indiaMARTLogo}
              alt="IndiaMART"
              border="0"
              name="logo"
            />
          </h1>
        </div>
        <div className="login-container" id="login-auth">
          <div className="login-box ">
            <h2 style={{fontWeight:400, color:"black", padding:"10px"}}>Login to <span style={{fontWeight:"bold", color:"#2a2d93", wordBreak:"break-all"}}>Inbound CRM</span></h2>
            <GoogleLogin 
                onSuccess={handleLoginSuccess} 
                onError={() => console.error("Login Failed")} 
                useOneTap={false}
                theme="outline"
                size="large"
                text="Sign in with Google"
                logo_alignment="left"
              />
              {
                loginMessage && <p style={{color:"red", fontSize:'13px'}}>{loginMessage}</p>
              }
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginComponent;